<template>
    <div class="alert-forgettable-wrapper" v-bind:class="{ 'alert-forgettable-modal': isModal }" :id="'alert_forgetable_' + name">
        <div class="alert-forgettable-overlay" v-if="isModal"></div>
        <div class="alert-forgettable-content">
            <div class="content-wrapper">
                {{ content }}
            </div>
            <div class="forget-wrapper" v-if="isForgettable">
                <small>
                    <label>
                        <input type="checkbox" v-model="forget">
                        <span v-lang.noVolverAMostrar>No volver a mostrar este mensaje</span>
                    </label>
                </small>
            </div>
            <div class="button-wrapper">
                <button @click="onOk">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modal',
    props: {
        'name': {
            type: String,
            required: true,
            default: ''
        },
        'content': {
            type: String,
            required: true,
            default: ''
        },
        'isModal': {
            type: Boolean,
            required: false,
            default: false
        },
        'isForgettable': {
            type: Boolean,
            required: false,
            default: true
        },
        'callback': {
            type: Function,
            required: false
        }
    },
    data () {
        return {
            forget: false
        };
    },
    mounted () {
        this.language = this.$getLang();
    },
    methods: {
        onOk () {
            if (this.callback && typeof this.callback === 'function') {
                this.callback();
            }
            this.$alertForgettableRemove(this.name, this.forget);
        }
    }
};
</script>

<style scoped>
    .alert-forgettable-wrapper {
        z-index: 2150;
    }
    .alert-forgettable-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    .alert-forgettable-overlay {
        position: relative;
        width: 100%;
        height: 100%;
        background: #00000099;
    }
    .alert-forgettable-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        min-width: 300px;
        max-width: 80vw;
        padding: 1rem;
        z-index: 2151;
        box-shadow: 1px 2px 5px 2px rgba(0,0,0,.2);
    }
    .alert-forgettable-content .content-wrapper {
        text-align: center;
        font-size: 1.1rem;
        margin-bottom: 1rem;
    }
    .alert-forgettable-content .forget-wrapper {
        text-align: center;
        margin: 0 0 .5em;
    }
    .alert-forgettable-content .forget-wrapper input {
        vertical-align: -2px;
    }
    .alert-forgettable-content .button-wrapper {
        text-align: center;
    }
    .alert-forgettable-content .button-wrapper button {
        border: 1px solid #777;
        color: #777;
        background: white;
        border-radius: 4px;
        padding: .5em 1em;
    }
    .alert-forgettable-content .button-wrapper button:hover {
        background: #EEE;
    }
</style>



// WEBPACK FOOTER //
// src/components/components/AlertForgettable.vue